module.exports = __webpack_public_path__ + "static/media/osteopatia.326297a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/iconos/osteopatia.png
// module id = 93
// module chunks = 0